import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../_metronic/layout";
import { ROLES } from "../utils/constants";
import CustomersPage from "./modules/ContentManager/customers/CustomersPage";
import EditCustomersPage from "./modules/ContentManager/customers/EditCustomersPage";
import EditOffersPage from "./modules/ContentManager/offers/EditOffersPage";
import OffersPage from "./modules/ContentManager/offers/OffersPage";
import EditPartidasCategoriesPage from "./modules/ContentManager/partidaCategories/EditPartidasCategoriesPage";
import PartidasCategoriesPage from "./modules/ContentManager/partidaCategories/PartidasCategoriesPage";
import EditPartidasPage from "./modules/ContentManager/partidas/EditPartidasPage";
import PartidasPage from "./modules/ContentManager/partidas/PartidasPage";
import EditProductFamiliesPage from "./modules/ContentManager/productFamilies/EditProductFamiliesPage";
import ProductFamiliesPage from "./modules/ContentManager/productFamilies/ProductFamiliesPage";
import EditProductsPage from "./modules/ContentManager/products/EditProductsPage";
import ProductsPage from "./modules/ContentManager/products/ProductsPage";
import EditProductUnitTypesPage from "./modules/ContentManager/productUnitTypes/EditProductUnitTypesPage";
import ProductUnitTypesPage from "./modules/ContentManager/productUnitTypes/ProductUnitTypesPage";
import EditSuppliersPage from "./modules/ContentManager/suppliers/EditSuppliersPage";
import SuppliersPage from "./modules/ContentManager/suppliers/SuppliersPage";
import EditSupplierTypesPage from "./modules/ContentManager/supplierTypes/EditSupplierTypesPage";
import SupplierTypesPage from "./modules/ContentManager/supplierTypes/SupplierTypesPage";
import EditUsersPage from "./modules/ContentManager/users/EditUsersPage";
import UsersPage from "./modules/ContentManager/users/UsersPage";
import { DashboardPage } from "./pages/DashboardPage";
import EditProductMarcaPage from "./modules/ContentManager/productMarca/EditProductMarcaPage";
import ProductMarcaPage from "./modules/ContentManager/productMarca/ProductMarcaPage";

export default function BasePage() {
  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  const adminAccess =
    loggedUser?.role?.rango === ROLES.SUPER_ADMIN ||
    loggedUser?.role?.rango === ROLES.ADMIN;

  return (
    <Switch>
      {/* Redirect from root URL to /dashboard. */}
      <Redirect exact from="/" to="/dashboard" />
      <ContentRoute path="/dashboard" component={DashboardPage} />

      {/* COMERCIAL */}
      {/* Clientes */}
      <ContentRoute from="/clientes/:id?/edit" component={EditCustomersPage} />
      <ContentRoute from="/clientes" component={CustomersPage} />

      {/* Proveedores */}
      <ContentRoute
        from="/proveedores/:id?/edit"
        component={EditSuppliersPage}
      />
      <ContentRoute from="/proveedores" component={SuppliersPage} />

      {/* Ofertas */}
      <ContentRoute
        from="/ofertas/:id?/:revisionNumber?/edit"
        component={EditOffersPage}
      />
      <ContentRoute from="/ofertas" component={OffersPage} />

      {/* AMINISTRACION */}
      {/* Usuarios */}
      <ContentRoute
        from="/usuarios/:id?/edit"
        component={adminAccess ? EditUsersPage : DashboardPage}
      />
      <ContentRoute
        from="/usuarios"
        component={adminAccess ? UsersPage : DashboardPage}
      />

      {/* Categorias de partidas */}
      <ContentRoute
        from="/categorias-partidas/:id?/edit"
        component={adminAccess ? EditPartidasCategoriesPage : DashboardPage}
      />
      <ContentRoute
        from="/categorias-partidas"
        component={adminAccess ? PartidasCategoriesPage : DashboardPage}
      />

      {/* Productos */}
      <ContentRoute
        from="/productos/:id?/edit"
        component={adminAccess ? EditProductsPage : DashboardPage}
      />
      <ContentRoute
        from="/productos"
        component={adminAccess ? ProductsPage : DashboardPage}
      />

      {/* Familias de productos */}
      <ContentRoute
        from="/familias-productos/:id?/edit"
        component={adminAccess ? EditProductFamiliesPage : DashboardPage}
      />
      <ContentRoute
        from="/familias-productos"
        component={adminAccess ? ProductFamiliesPage : DashboardPage}
      />

      {/* Tipos de unidades de productos */}
      <ContentRoute
        from="/tipos-unidades-productos/:id?/edit"
        component={adminAccess ? EditProductUnitTypesPage : DashboardPage}
      />
      <ContentRoute
        from="/tipos-unidades-productos"
        component={adminAccess ? ProductUnitTypesPage : DashboardPage}
      />

      {/* Marcas de productos */}
      <ContentRoute
        from="/marcas-productos/:id?/edit"
        component={adminAccess ? EditProductMarcaPage : DashboardPage}
      />
      <ContentRoute
        from="/marcas-productos"
        component={adminAccess ? ProductMarcaPage : DashboardPage}
      />

      {/* Productos */}
      <ContentRoute
        from="/partidas/:id?/edit"
        component={adminAccess ? EditPartidasPage : DashboardPage}
      />
      <ContentRoute
        from="/partidas"
        component={adminAccess ? PartidasPage : DashboardPage}
      />

      {/* Tipos de proveedores */}
      <ContentRoute
        from="/tipos-proveedores/:id?/edit"
        component={adminAccess ? EditSupplierTypesPage : DashboardPage}
      />
      <ContentRoute
        from="/tipos-proveedores"
        component={adminAccess ? SupplierTypesPage : DashboardPage}
      />

      <Redirect to="/error" />
    </Switch>
  );
}
